export default __webpack_public_path__ + "static/media/code_writter.06ee422a.png";